<template>
	<div>
		<vue-particles color="#FFF" :particleOpacity="0.7" :particlesNumber="60" shapeType="circle" :particleSize="4"
			linesColor="#FFF" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3"
			:hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" style="z-index: 10;">
		</vue-particles>

		<!-- 人机校验码 提示框 -->
		<el-dialog title="" :visible.sync="dialogVisible" width="30%" style="z-index: 1500;">
			<div class="flex items-center justify-center">
				<div class="bg-white p-8 rounded-lg  w-96">
					<h1 class="text-2xl font-bold text-center mb-6">
						<!-- 人机校验 -->
						{{ $t('language000280') }}
					</h1>
					<div class="mb-4">
						<div class="bg-gray-200 h-16 flex items-center justify-center mb-2 overflow-hidden">
							<img :src="captchaImageUrl" alt="验证码" class="w-full h-full object-cover" />
						</div>
						<div class="flex justify-between items-center">
							<p class="text-sm text-gray-600">
								<!-- 看不清？点击图片刷新 -->
								{{ $t('language000281') }}
							</p>
							<button @click="refreshCaptcha" class="text-blue-500 hover:text-blue-700">
								<i class="fas fa-sync-alt"></i>
								<!-- 刷新 -->
								{{ $t('language000282') }}
							</button>
						</div>
					</div>
					<div class="mb-4">
						<label for="captcha" class="block text-sm font-medium text-gray-700 mb-1">
							<!-- 请输入验证码 -->
							{{ $t('language000283') }}
						</label>
						<div class="relative">
							<input type="text" id="captcha" v-model="captchaInput"
								class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 !rounded-button"
								:placeholder="$t('language000284')" />
							<span class="absolute inset-y-0 right-0 flex items-center pr-3">
								<i class="fas fa-shield-alt text-gray-400"></i>
							</span>
						</div>
					</div>
					<button @click="submitCaptcha"
						class="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-150 ease-in-out !rounded-button whitespace-nowrap">
						<!-- 验证 -->
						{{ $t('language000285') }}
					</button>
				</div>
			</div>
		</el-dialog>


		<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">

			<img src="../../assets/login_bg01.jpg"
				style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; object-fit: cover;" />

			<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">

			<div class="w-[420px] bg-white rounded-lg shadow-xl p-8" style="z-index: 1000; width: 450px;">

				<!-- 数据加载提示框 -->
				<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
					<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
						<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
					</div>
				</van-overlay>

				<!-- Logo区域 -->
				<div class="text-center mb-8">
					<div style="display: flex; justify-content: center;">
						<img src="../../assets/login_bg02.jpg" style="width: 90px; height: 90px;" />
					</div>

					<p class="text-gray-500 mt-3" style="font-size: 24px;">{{ $t('language000101') }}</p>
				</div>

				<!-- 登录选项卡 -->
				<div class="flex mb-6 border-b">
					<button v-for="tab in tabs" :key="tab.key" @click="activeTab = tab.key"
						:class="[ 'flex-1 pb-3 text-center font-medium transition-colors', activeTab === tab.key ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500' ]">
						{{ tab.label }}
					</button>
				</div>

				<!-- 输入区域 -->
				<div class="space-y-4">
					<!-- 区号选择与手机号输入 -->
					<div class="relative">
						<div v-if="activeTab === 'phone'" class="flex relative">
							<button
								class="flex items-center justify-between px-3 py-3 border rounded-l-lg bg-gray-50 text-gray-700 border-r-0 min-w-[140px]"
								@click="showCountrySelect = !showCountrySelect">
								<div class="flex items-center justify-between">
									<span>+{{ selectedCountry.code }}</span>
								</div>
								<i class="fas fa-chevron-down ml-2 text-gray-400 text-xs"></i>
							</button>
							<input type="tel" :placeholder="$t('language000006')"
								class="flex-1 px-4 py-3 border rounded-r-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
								v-model="account" />

							<!-- 国家选择下拉框 -->
							<div v-show="showCountrySelect" style="max-height: 320px;"
								class="absolute top-full left-0 w-[280px] max-h-[320px] overflow-y-auto bg-white border rounded-lg shadow-lg z-10 mt-1">
								<!-- 搜索框 会报错  所以隐藏了 -->
								<div v-show="false" class="sticky top-0 bg-white border-b">
									<div class="p-2 relative">
										<input type="text" v-model="searchCountry" placeholder="搜索国家/地区"
											class="w-full px-8 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" />
										<i
											class="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
									</div>
								</div>
								<div class="divide-y">
									<div v-for="country in filteredCountries" :key="country.code"
										@click="selectCountry(country)"
										class="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
										<span class="ml-3 text-gray-700">{{ country.name }}</span>
										<span class="ml-auto text-gray-500">+{{ country.code }}</span>
									</div>
								</div>
							</div>
						</div>
						<input v-else type="email" :placeholder="$t('language000097')"
							class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
							v-model="account" />
						<i class="fas fa-user absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
					</div>

					<!-- 登录方式选择 -->
					<div class="flex space-x-6 px-2">
						<label class="flex items-center cursor-pointer">
							<input type="radio" v-model="loginType" value="password" class="hidden" />
							<div
								:class="['w-4 h-4 rounded-full border flex items-center justify-center', loginType === 'password' ? 'border-red-600' : 'border-gray-300']">
								<div class="w-2 h-2 rounded-full bg-red-600" v-if="loginType === 'password'"></div>
							</div>
							<span class="ml-2 text-gray-700">{{ $t('language000119') }}</span>
						</label>
						<label class="flex items-center cursor-pointer">
							<input type="radio" v-model="loginType" value="code" class="hidden" />
							<div
								:class="[ 'w-4 h-4 rounded-full border flex items-center justify-center', loginType === 'code' ? 'border-red-600' : 'border-gray-300' ]">
								<div class="w-2 h-2 rounded-full bg-red-600" v-if="loginType === 'code'"></div>
							</div>
							<span class="ml-2 text-gray-700">{{ $t('language000120') }}</span>
						</label>
					</div>

					<!-- 密码/验证码输入 -->
					<div class="relative" v-if="loginType === 'password'">
						<input :type="showPassword ? 'text' : 'password'" :placeholder="$t('language000121')"
							class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
							v-model="password" />
						<i :class="['fas', showPassword ? 'fa-eye-slash' : 'fa-eye', 'absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer']"
							@click="showPassword = !showPassword"></i>
					</div>
					<div class="relative" v-else>
						<input type="text" :placeholder="$t('language000008')"
							class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
							v-model="verificationCode" />
						<button
							:class="[ 'absolute right-2 top-1/2 transform -translate-y-1/2 px-4 py-1 rounded-lg text-sm !rounded-button',  canSendCode ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-200 text-gray-400' ]"
							@click="sendVerificationCode" :disabled="!canSendCode">
							{{ codeButtonText }}
						</button>
					</div>
				</div>

				<!-- 登录按钮 -->
				<button
					class="w-full mt-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors !rounded-button"
					@click="handleLogin">
					{{ $t('language000051') }}
				</button>

				<!-- 辅助功能区 -->
				<div class="mt-4 flex justify-between text-sm">
					<a class="text-red-600 hover:text-red-700"></a>
					<button class="text-red-600 hover:text-red-700"
						@click.preven="toRegister">{{ $t('language000122') }}</button>
				</div>

				<!-- 底部协议 -->
				<div class="text-center text-sm text-gray-500 mt-4">
					{{ $t('language000123') }}
					<button class="text-red-500 hover:text-red-800"
						@click.preven="toDeveloperAgreement">{{ $t('language000112') }}</button>
				</div>

			</div>
			<!-- 遮罩层 -->
			<div v-if="showCountrySelect" class="fixed inset-0 z-0" @click="showCountrySelect = false"></div>
		</div>

	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../src/utils/StringUtil.js';

	export default {
		mounted() {
			const token = Cookies.get("tokenDevelopment");
			if (token) {
				//跳转到分销
				this.$router.push({ //跳转到首页
					path: '/DevelopersHome',
					query: {}
				});
				console.log("有token 直接去首页");
			} else {
				console.log("没有有token");
			}

			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 如果语言受支持，则设置为用户语言，否则设置为默认语言
			//this.$i18n.locale = 'en'; // 设置为英语
		},
		data() {
			return {
				countries: [{
					name: '中国',
					code: '86'
				}, {
					name: 'Hong Kong',
					code: '852'
				}, {
					name: 'Macau',
					code: '853'
				}, {
					name: 'Taiwan',
					code: '886'
				}, {
					name: 'United States',
					code: '1'
				}, {
					name: 'Afghanistan',
					code: '93'
				}, {
					name: 'Albania',
					code: '355'
				}, {
					name: 'Algeria',
					code: '213'
				}, {
					name: 'American Samoa',
					code: '1684'
				}, {
					name: 'Andorra',
					code: '376'
				}, {
					name: 'Angola',
					code: '244'
				}, {
					name: 'Anguilla',
					code: '1264'
				}, {
					name: 'Antigua and Barbuda',
					code: '1268'
				}, {
					name: 'Argentina',
					code: '54'
				}, {
					name: 'Armenia',
					code: '374'
				}, {
					name: 'Aruba',
					code: '297'
				}, {
					name: 'Australia',
					code: '61'
				}, {
					name: 'Austria',
					code: '43'
				}, {
					name: 'Azerbaijan',
					code: '994'
				}, {
					name: 'Bahamas',
					code: '1242'
				}, {
					name: 'Bahrain',
					code: '973'
				}, {
					name: 'Bangladesh',
					code: '880'
				}, {
					name: 'Barbados',
					code: '1246'
				}, {
					name: 'Belarus',
					code: '375'
				}, {
					name: 'Belgium',
					code: '32'
				}, {
					name: 'Belize',
					code: '501'
				}, {
					name: 'Benin',
					code: '229'
				}, {
					name: 'Bermuda',
					code: '1441'
				}, {
					name: 'Bhutan',
					code: '975'
				}, {
					name: 'Bolivia',
					code: '591'
				}, {
					name: 'Bosnia and Herzegovina',
					code: '387'
				}, {
					name: 'Botswana',
					code: '267'
				}, {
					name: 'Brazil',
					code: '55'
				}, {
					name: 'Brunei',
					code: '673'
				}, {
					name: 'British Virgin Islands',
					code: '1340'
				}, {
					name: 'Bulgaria',
					code: '359'
				}, {
					name: 'Burkina Faso',
					code: '226'
				}, {
					name: 'Burundi',
					code: '257'
				}, {
					name: 'Cambodia',
					code: '855'
				}, {
					name: 'Cameroon',
					code: '237'
				}, {
					name: 'Canada',
					code: '1'
				}, {
					name: 'Cape Verde',
					code: '238'
				}, {
					name: 'Cayman Islands',
					code: '1345'
				}, {
					name: 'Central African Republic',
					code: '236'
				}, {
					name: 'Chad',
					code: '235'
				}, {
					name: 'Chile',
					code: '56'
				}, {
					name: 'Colombia',
					code: '57'
				}, {
					name: 'Comoros',
					code: '269'
				}, {
					name: 'Cook Islands',
					code: '682'
				}, {
					name: 'Costa Rica',
					code: '506'
				}, {
					name: 'Croatia',
					code: '385'
				}, {
					name: 'Cuba',
					code: '53'
				}, {
					name: 'Curaçao',
					code: '599'
				}, {
					name: 'Cyprus',
					code: '357'
				}, {
					name: 'Czech Republic',
					code: '420'
				}, {
					name: 'Democratic Republic of the Congo',
					code: '243'
				}, {
					name: 'Denmark',
					code: '45'
				}, {
					name: 'Djibouti',
					code: '253'
				}, {
					name: 'Dominica',
					code: '1767'
				}, {
					name: 'Dominican Republic',
					code: '1809'
				}, {
					name: 'Ecuador',
					code: '593'
				}, {
					name: 'Egypt',
					code: '20'
				}, {
					name: 'El Salvador',
					code: '503'
				}, {
					name: 'Equatorial Guinea',
					code: '240'
				}, {
					name: 'Eritrea',
					code: '291'
				}, {
					name: 'Estonia',
					code: '372'
				}, {
					name: 'Ethiopia',
					code: '251'
				}, {
					name: 'Faroe Islands',
					code: '298'
				}, {
					name: 'Fiji',
					code: '679'
				}, {
					name: 'Finland',
					code: '358'
				}, {
					name: 'France',
					code: '33'
				}, {
					name: 'French Guiana',
					code: '594'
				}, {
					name: 'French Polynesia',
					code: '689'
				}, {
					name: 'Gabon',
					code: '241'
				}, {
					name: 'Gambia',
					code: '220'
				}, {
					name: 'Georgia',
					code: '995'
				}, {
					name: 'Germany',
					code: '49'
				}, {
					name: 'Ghana',
					code: '233'
				}, {
					name: 'Gibraltar',
					code: '350'
				}, {
					name: 'Greece',
					code: '30'
				}, {
					name: 'Grenada',
					code: '1473'
				}, {
					name: 'Guadeloupe',
					code: '590'
				}, {
					name: 'Guam',
					code: '1671'
				}, {
					name: 'Guatemala',
					code: '502'
				}, {
					name: 'Guinea',
					code: '224'
				}, {
					name: 'Guinea-Bissau',
					code: '245'
				}, {
					name: 'Guyana',
					code: '592'
				}, {
					name: 'Haiti',
					code: '509'
				}, {
					name: 'Honduras',
					code: '504'
				}, {
					name: 'Hungary',
					code: '36'
				}, {
					name: 'Iceland',
					code: '354'
				}, {
					name: 'India',
					code: '91'
				}, {
					name: 'Indonesia',
					code: '62'
				}, {
					name: 'Iran',
					code: '98'
				}, {
					name: 'Iraq',
					code: '964'
				}, {
					name: 'Ireland',
					code: '353'
				}, {
					name: 'Israel',
					code: '972'
				}, {
					name: 'Italy',
					code: '39'
				}, {
					name: 'Ivory Coast',
					code: '225'
				}, {
					name: 'Jamaica',
					code: '1876'
				}, {
					name: 'Japan',
					code: '81'
				}, {
					name: 'Jordan',
					code: '962'
				}, {
					name: 'Kazakhstan',
					code: '7'
				}, {
					name: 'Kenya',
					code: '254'
				}, {
					name: 'Kiribati',
					code: '686'
				}, {
					name: 'Kuwait',
					code: '965'
				}, {
					name: 'Kyrgyzstan',
					code: '996'
				}, {
					name: 'Laos',
					code: '856'
				}, {
					name: 'Latvia',
					code: '371'
				}, {
					name: 'Lebanon',
					code: '961'
				}, {
					name: 'Lesotho',
					code: '266'
				}, {
					name: 'Liberia',
					code: '231'
				}, {
					name: 'Libya',
					code: '218'
				}, {
					name: 'Liechtenstein',
					code: '423'
				}, {
					name: 'Lithuania',
					code: '370'
				}, {
					name: 'Luxembourg',
					code: '352'
				}, {
					name: 'North Macedonia',
					code: '389'
				}, {
					name: 'Madagascar',
					code: '261'
				}, {
					name: 'Malawi',
					code: '265'
				}, {
					name: 'Malaysia',
					code: '60'
				}, {
					name: 'Maldives',
					code: '960'
				}, {
					name: 'Mali',
					code: '223'
				}, {
					name: 'Malta',
					code: '356'
				}, {
					name: 'Martinique',
					code: '596'
				}, {
					name: 'Mauritania',
					code: '222'
				}, {
					name: 'Mauritius',
					code: '230'
				}, {
					name: 'Mayotte',
					code: '262'
				}, {
					name: 'Mexico',
					code: '52'
				}, {
					name: 'Moldova',
					code: '373'
				}, {
					name: 'Monaco',
					code: '377'
				}, {
					name: 'Mongolia',
					code: '976'
				}, {
					name: 'Montenegro',
					code: '382'
				}, {
					name: 'Montserrat',
					code: '1664'
				}, {
					name: 'Morocco',
					code: '212'
				}, {
					name: 'Mozambique',
					code: '258'
				}, {
					name: 'Myanmar',
					code: '95'
				}, {
					name: 'Namibia',
					code: '264'
				}, {
					name: 'Nepal',
					code: '977'
				}, {
					name: 'Netherlands',
					code: '31'
				}, {
					name: 'New Caledonia',
					code: '687'
				}, {
					name: 'New Zealand',
					code: '64'
				}, {
					name: 'Nicaragua',
					code: '505'
				}, {
					name: 'Niger',
					code: '227'
				}, {
					name: 'Nigeria',
					code: '234'
				}, {
					name: 'Norway',
					code: '47'
				}, {
					name: 'Oman',
					code: '968'
				}, {
					name: 'Pakistan',
					code: '92'
				}, {
					name: 'Palau',
					code: '680'
				}, {
					name: 'Palestine',
					code: '970'
				}, {
					name: 'Panama',
					code: '507'
				}, {
					name: 'Papua New Guinea',
					code: '675'
				}, {
					name: 'Paraguay',
					code: '595'
				}, {
					name: 'Peru',
					code: '51'
				}, {
					name: 'Philippines',
					code: '63'
				}, {
					name: 'Poland',
					code: '48'
				}, {
					name: 'Portugal',
					code: '351'
				}, {
					name: 'Puerto Rico',
					code: '1787'
				}, {
					name: 'Qatar',
					code: '974'
				}, {
					name: 'Republic of the Congo',
					code: '242'
				}, {
					name: 'Réunion',
					code: '262'
				}, {
					name: 'Romania',
					code: '40'
				}, {
					name: 'Russia',
					code: '7'
				}, {
					name: 'Rwanda',
					code: '250'
				}, {
					name: 'Saint Kitts and Nevis',
					code: '1869'
				}, {
					name: 'Saint Lucia',
					code: '1758'
				}, {
					name: 'Saint Pierre and Miquelon',
					code: '508'
				}, {
					name: 'Saint Vincent and the Grenadines',
					code: '1784'
				}, {
					name: 'Samoa',
					code: '685'
				}, {
					name: 'San Marino',
					code: '378'
				}, {
					name: 'Sao Tome and Principe',
					code: '239'
				}, {
					name: 'Saudi Arabia',
					code: '966'
				}, {
					name: 'Senegal',
					code: '221'
				}, {
					name: 'Serbia',
					code: '381'
				}, {
					name: 'Seychelles',
					code: '248'
				}, {
					name: 'Sierra Leone',
					code: '232'
				}, {
					name: 'Singapore',
					code: '65'
				}, {
					name: 'Sint Maarten',
					code: '1721'
				}, {
					name: 'Slovakia',
					code: '421'
				}, {
					name: 'Slovenia',
					code: '386'
				}, {
					name: 'Solomon Islands',
					code: '677'
				}, {
					name: 'Somalia',
					code: '252'
				}, {
					name: 'South Africa',
					code: '27'
				}, {
					name: 'South Korea',
					code: '82'
				}, {
					name: 'Spain',
					code: '34'
				}, {
					name: 'Sri Lanka',
					code: '94'
				}, {
					name: 'Sudan',
					code: '249'
				}, {
					name: 'Suriname',
					code: '597'
				}, {
					name: 'Swaziland',
					code: '268'
				}, {
					name: 'Sweden',
					code: '46'
				}, {
					name: 'Switzerland',
					code: '41'
				}, {
					name: 'Syria',
					code: '963'
				}, {
					name: 'Tajikistan',
					code: '992'
				}, {
					name: 'Tanzania',
					code: '255'
				}, {
					name: 'Thailand',
					code: '66'
				}, {
					name: 'Timor-Leste',
					code: '670'
				}, {
					name: 'Togo',
					code: '228'
				}, {
					name: 'Tonga',
					code: '676'
				}, {
					name: 'Trinidad and Tobago',
					code: '1868'
				}, {
					name: 'Tunisia',
					code: '216'
				}, {
					name: 'Turkey',
					code: '90'
				}, {
					name: 'Turkmenistan',
					code: '993'
				}, {
					name: 'Turks and Caicos Islands',
					code: '1649'
				}, {
					name: 'Uganda',
					code: '256'
				}, {
					name: 'Ukraine',
					code: '380'
				}, {
					name: 'United Arab Emirates',
					code: '971'
				}, {
					name: 'United Kingdom',
					code: '44'
				}, {
					name: 'Uruguay',
					code: '598'
				}, {
					name: 'U.S. Virgin Islands',
					code: '1284'
				}, {
					name: 'Uzbekistan',
					code: '998'
				}, {
					name: 'Vanuatu',
					code: '678'
				}, {
					name: 'Venezuela',
					code: '58'
				}, {
					name: 'Vietnam',
					code: '84'
				}, {
					name: 'Yemen',
					code: '967'
				}, {
					name: 'Zambia',
					code: '260'
				}, {
					name: 'Zimbabwe',
					code: '263'
				}],
				loadingData: false, // 是否显示加载效果 (加载数据)
				dialogVisible: false, //人机校验码提示框
				uuid: '', //图片的ID
				captchaImageUrl: '', //图形验证码图片
				captchaInput: '', //图形验证码
				activeTab: 'phone',
				loginType: 'password',
				account: '', //手机号+邮箱
				password: '', //密码
				verificationCode: '', //验证码
				showPassword: false,
				showCountrySelect: false,
				searchCountry: '',
				selectedCountry: {
					name: '中国',
					code: '86'
				},
				countdown: 0,
			};
		},
		computed: {
			tabs() {
				return [{
					key: 'phone',
					label: this.$t('language000103') // 手机号登录
				}, {
					key: 'email',
					label: this.$t('language000118') // 邮箱登录
				}];
			},
			filteredCountries() {
				const search = this.searchCountry.toLowerCase();
				return this.countries.filter(country =>
					country.name.toLowerCase().includes(search) ||
					country.code.includes(search)
				);
			},
			canSendCode() {
				return this.countdown === 0;
			},
			codeButtonText() {
				return this.countdown > 0 ? `${this.countdown} ${this.$t('language000104')}` : this.$t('language000105');
			}
		},
		methods: {
			sendVerificationCode() { //获取验证码
				if (this.activeTab == "phone") { //手机号注册
					if (this.selectedCountry.code.length <= 0) {
						this.$message.error(this.$t('language000117')); //请选择区号
						return
					}
					if (this.account.length <= 0) {
						this.$message.error(this.$t('language000006')); //请输入手机号码
						return
					}
				} else if (this.activeTab == "email") { //邮箱注册
					if (this.account.length <= 0) {
						this.$message.error(this.$t('language000097')); //请输入邮箱
						return
					}
				} else {
					alert('类型错误');
				}

				this.refreshCaptcha();

				//this.dialogVisible = true;
				//发送验证码
				/* */

			},
			refreshCaptcha() { //刷新 获取验证码
				this.loadingData = true;
				axios.get(this.$p_url_Developers + '/captchaImage')
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.uuid = response.data.uuid //图片验证码ID
							this.captchaImageUrl = response.data.img; //图片验证码

							//加载图形验证码
							const img = new Image(); // 创建新的Image对象
							img.onload = () => { // 当图像加载完成时，将Base64字符串赋值给显示图像的变量
								this.captchaImageUrl = img.src;
								this.dialogVisible = true; //显示提示框
							};
							img.onerror = (error) => { // 当图像加载失败时，显示错误信息
								console.error('加载图像失败：', error);
							};
							// 将Base64字符串赋值给图像的src属性
							img.src = `data:image/png;base64,${this.captchaImageUrl}`;

						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			submitCaptcha() { //提交验证码

				if (this.captchaInput) {
					if (this.activeTab == "phone") { //发送手机验证码
						this.loadingData = true;
						axios.post(this.$p_url_Developers + '/sms/sendSmsCode', {
								imgCode: this.captchaInput, //图形验证码不能为空
								imgUuid: this.uuid, //图形验证码UUID不能为空
								phone: this.account, //手机号码
								restType: 2, //1:注册，2登录，3找回密码
								type: 2, //0：注册国内短信、1：注册国际短信、2:登录国内验证码、3、登录国际短信、4、注销国内短信、5、注销国际短信
								zone: this.selectedCountry.code //国家区号
							})
							.then(response => {
								this.loadingData = false;
								console.log("返回的值：", response.data)
								if (response.data.code === 200) { // 检查状态
									this.$message({ //提示成功
										message: this.$t('language000064'),
										type: 'success'
									});
									this.dialogVisible = false; //隐藏提示框

									this.countdown = 60;
									const timer = setInterval(() => {
										this.countdown--;
										if (this.countdown === 0) {
											clearInterval(timer);
										}
									}, 1000);

								} else {
									alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
								}
							})
							.catch(error => {
								alert("请求失败：" + error);
							});
					}

					if (this.activeTab == "email") { //发送邮箱验证码
						this.loadingData = true;
						axios.post(this.$p_url_Developers + '/sms/sendEmailCode', {
								imgCode: this.captchaInput, //图形验证码不能为空
								imgUuid: this.uuid, //图形验证码UUID不能为空
								emailAddress: this.account, //邮箱地址
								restType: 2, //1:注册，2登录，3找回密码
							})
							.then(response => {
								this.loadingData = false;
								console.log("返回的值：", response.data)
								if (response.data.code === 200) { // 检查状态
									this.$message({ //提示成功
										message: this.$t('language000064'),
										type: 'success'
									});
									this.dialogVisible = false; //隐藏提示框

									this.countdown = 60;
									const timer = setInterval(() => {
										this.countdown--;
										if (this.countdown === 0) {
											clearInterval(timer);
										}
									}, 1000);

								} else {
									alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
								}
							})
							.catch(error => {
								alert("请求失败：" + error);
							});
					}


				} else {
					this.$message.error(this.$t('language000008')); //请输入验证码
				}
			},
			handleLogin() { //登录
				console.log({
					loginType: this.loginType,
					account: this.activeTab === 'phone' ? `+${this.selectedCountry.code} ${this.account}` : this
						.account,
					password: this.password,
					verificationCode: this.verificationCode
				});

				const requestData = {}; //传递的参数
				if (this.activeTab == "phone") { //手机号

					if (this.account.length <= 0) {
						this.$message.error(this.$t('language000006')); //请输入手机号码
						return
					}

					if (this.loginType == "password") { //密码登录
						if (this.password.length <= 0) {
							this.$message.error(this.$t('language000121')); //请输入密码
							return
						}
						console.log("手机号 密码登录");
						requestData.password = this.password; //密码
						requestData.phoneNumber = this.account; //手机号
						requestData.loginType = 3; //1手机号+验证码，2邮箱+验证码，3手机号+密码 4邮箱+密码
					}

					if (this.loginType == "code") { //验证码登录
						if (this.selectedCountry.code.length <= 0) {
							this.$message.error(this.$t('language000117')); //请选择区号
							return
						}
						console.log("手机号 验证码登录");
						requestData.smsCode = this.verificationCode; //验证码
						requestData.zone = this.selectedCountry.code; //区号
						requestData.phoneNumber = this.account; //手机号
						requestData.loginType = 1; //1手机号+验证码，2邮箱+验证码，3手机号+密码 4邮箱+密码
					}

				} else if (this.activeTab == "email") { //邮箱

					if (this.account.length <= 0) {
						this.$message.error(this.$t('language000097')); //请输入邮箱
						return
					}

					if (this.loginType == "password") { //密码登录
						console.log("邮箱 密码登录");
						requestData.password = this.password; //密码
						requestData.emailAddress = this.account; //邮箱地址
						requestData.loginType = 4; //1手机号+验证码，2邮箱+验证码，3手机号+密码 4邮箱+密码
					}

					if (this.loginType == "code") { //验证码登录
						console.log("邮箱 验证码登录");
						requestData.smsCode = this.verificationCode; //验证码
						requestData.zone = this.selectedCountry.code; //区号
						requestData.emailAddress = this.account; //邮箱地址
						requestData.loginType = 2; //1手机号+验证码，2邮箱+验证码，3手机号+密码 4邮箱+密码
					}

				} else {
					alert('类型错误');
					return
				}

				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/platform/info/login', requestData)
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						if (response.data.code === 200) { // 检查状态
							this.dialogVisible = false; //隐藏提示框
							Cookies.set("tokenDevelopment", "Bearer " + response.data.data, {
								expires: 1
							});
							console.log("缓存的token：", Cookies.get("tokenDevelopment"))
							this.$router.push({
								path: '/DevelopersHome',
								query: {}
							});
						} else {
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => {
						alert("请求失败：" + error);
					});
			},
			selectCountry(country) { //选择国家
				if (country) {
					console.log('选择的国家:', country); // 调试信息
					this.selectedCountry = country;
					console.log('选择的国家01:', country); // 调试信息
					this.showCountrySelect = false;
					console.log('选择的国家02:', country); // 调试信息
				} else {
					console.error('选择的国家不存在');
				}
			},
			toRegister(event) { //去注册
				event.stopPropagation();
				this.$router.push({
					path: '/DevelopersRegister',
					query: {}
				});
			},
			toDeveloperAgreement(event) { //确开发者协议
				event.stopPropagation();
				let page = this.$router.resolve({
					path: '/DeveloperAgreement',
					query: {}
				});
				window.open(page.href, '_blank');
			}
			//...
		},

		//...
	};
</script>

<style>
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	#particles-js {
		width: 100%;
		height: calc(100% - 100px);
		position: absolute;
	}

	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f2f2f2;
	}

	.login-box {
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}
</style>